<template>
  <div id="app">
    <Navigation />
    <div class="container">
      <Breadcrumbs v-if="hasBreadcrumbs" :icon="this.$router.currentRoute.meta.icon" :mainPage="this.$router.currentRoute.meta.parent" :subPage="this.$router.currentRoute.name"/>
      <BackButton v-if="hasBackButton" />
      <div v-if="!hasBreadcrumbs && !hasBackButton" class="replaceBreadcrumbs" />
      <slot :pagina="currentPage"/>
      <Pagination
        v-if="hasPagination"
        :totalPages="totalpages"
        :maxVisible="showingAmount"
        :currentPage="currentPage"
        @pagechanged="onPageChange"
      />
    </div>

    <Modal v-if="this.isModalOpen" @closeModal="closeModal"/>
  </div>
</template>

<script>
import Navigation from "@/components/Navigation";
import Breadcrumbs from "@/components/Breadcrumbs";
import BackButton from "@/components/BackButton";
import Pagination from "@/components/Pagination";
import Modal from "@/components/AddModal";

export default {
  name: "Dashboard",
  components: {
    Navigation,
    Pagination,
    Breadcrumbs,
    BackButton,
    Modal,
  },
  data () {
    return {
      currentPage: 1,
      isModalOpen: false,
      totalpages: 6,
      componentKey: 0,
      showingAmount: 9
    };
  },
  props: {
    hasPagination: {
      type: Boolean,
      default: false
    },
    hasBreadcrumbs: {
      type: Boolean,
      default: false
    },
    hasBackButton: {
      type: Boolean,
      default: false
    },
    backRoute: "",
    amount: {
      type: Number,
      default: 5
    },
    amountToShow: {
      type: Number,
      default: 9
    },
    pagination: {
      currentPage: {
        type: Number,
        required: true
      },
      currentPage: {
        type: Number,
        required: true
      }
    },
    openModalHandler: {
      type: Boolean,
      default: false,
    },
  },
  mounted(){
    this.showingAmount = this.amountToShow
    this.calcTotalPages()
  },
  watch: {
    openModalHandler(oldVal, newVal) {
      oldVal !== newVal && this.openModal();
    },
    amount(val){
      this.calcTotalPages()
      this.currentPage = 1
    },
    amountToShow(val){
      this.showingAmount = val
      if(this.currentPage == this.totalpages) {
        this.currentPage = Math.ceil(this.amount / val)
      }
      this.calcTotalPages()
    }
  },
  methods: {
    onPageChange(page) {
      this.calcTotalPages()
      this.currentPage = page;
      this.$emit('currentPage', page)
    },
    calcTotalPages() {
      this.totalpages = Math.ceil(this.amount / this.showingAmount)
    },
    openModal() {
      this.isModalOpen = true
    },
    closeModal() {
      this.isModalOpen = false
      this.forceRerender()
    },
    forceRerender() {
      this.componentKey += 1;  
      this.$emit('componentKey', this.componentKey)
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/pages/container.scss";
// @import "@/style/components/nav.scss";

.breadcrumb {
  display: flex;
  flex-direction: row;
  margin-bottom: 25px;
  font-size: 14px;
  color: $grey;

}

.replaceBreadcrumbs {
  height: 45px;
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}
</style>